import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-reply-details-from-talkroom-user"
}
const _hoisted_2 = { class: "revico-community-talk-reply-details-from-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['revico-community-talk-reply-details', $props.reply.isBestAnswer ? 'revico-community-talk-best-answer' : '', $props.reply.isTenantReply ? 'revico-community-talk-reply-tenant' : ''])
  }, [
    ($props.reply.isTalkRoomOwner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["ReplyDate"], {
            replyDate: $props.reply.replyDate
          }, null, 8 /* PROPS */, ["replyDate"]),
          _createVNode($setup["CommunityTalkUser"], {
            viewModel: $setup.communityTalkUserViewModel,
            "post-date": $props.reply.replyDate,
            "new-arrival-badge-display-days": $setup.communityTalkStore.getGeneralSettings().newArrivalBadgeDisplayDays,
            "new-arrival-badge-text": $setup.communityTalkStore.getWordSettings().newArrivalBadgeText
          }, null, 8 /* PROPS */, ["post-date", "new-arrival-badge-display-days", "new-arrival-badge-text"]),
          _createVNode($setup["ReplyContents"], {
            contents: $props.reply.contents
          }, null, 8 /* PROPS */, ["contents"]),
          _createVNode($setup["ReplyResponseButton"], {
            nickName: $props.reply.nickName,
            contents: $props.reply.contents,
            "community-talk-store-key": $props.communityTalkStoreKey,
            replyPostStoreKey: $props.replyPostStoreKey
          }, null, 8 /* PROPS */, ["nickName", "contents", "community-talk-store-key", "replyPostStoreKey"]),
          _createVNode($setup["CommunityTalkMedia"], {
            images: $setup.props.reply.images,
            movies: $setup.props.reply.movies
          }, null, 8 /* PROPS */, ["images", "movies"]),
          _createVNode($setup["ReplyNice"], {
            niceCount: $props.reply.goodCount,
            replyId: $props.reply.replyId,
            communityTalkStoreKey: $props.communityTalkStoreKey
          }, null, 8 /* PROPS */, ["niceCount", "replyId", "communityTalkStoreKey"])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" トークルーム投稿者外のリプライ "),
          _createElementVNode("div", _hoisted_2, [
            _createVNode($setup["ReplyDate"], {
              replyDate: $props.reply.replyDate
            }, null, 8 /* PROPS */, ["replyDate"]),
            _createVNode($setup["CommunityTalkUser"], {
              viewModel: $setup.communityTalkUserViewModel,
              "post-date": $props.reply.replyDate,
              "new-arrival-badge-display-days": $setup.communityTalkStore.getGeneralSettings().newArrivalBadgeDisplayDays,
              "new-arrival-badge-text": $setup.communityTalkStore.getWordSettings().newArrivalBadgeText
            }, null, 8 /* PROPS */, ["post-date", "new-arrival-badge-display-days", "new-arrival-badge-text"]),
            _createVNode($setup["ReplyContents"], {
              contents: $props.reply.contents
            }, null, 8 /* PROPS */, ["contents"]),
            _createVNode($setup["ReplyResponseButton"], {
              nickName: $props.reply.nickName,
              contents: $props.reply.contents,
              "community-talk-store-key": $props.communityTalkStoreKey,
              replyPostStoreKey: $props.replyPostStoreKey
            }, null, 8 /* PROPS */, ["nickName", "contents", "community-talk-store-key", "replyPostStoreKey"]),
            _createVNode($setup["CommunityTalkMedia"], {
              images: $setup.props.reply.images,
              movies: $setup.props.reply.movies
            }, null, 8 /* PROPS */, ["images", "movies"]),
            _createVNode($setup["ReplyNice"], {
              niceCount: $props.reply.goodCount,
              replyId: $props.reply.replyId,
              communityTalkStoreKey: $props.communityTalkStoreKey
            }, null, 8 /* PROPS */, ["niceCount", "replyId", "communityTalkStoreKey"]),
            ($props.reply.isBestAnswer)
              ? (_openBlock(), _createBlock($setup["ReplyBestAnswerIcon"], {
                  key: 0,
                  bestAnswerTitle: $props.wordSettings.bestAnswerTitle
                }, null, 8 /* PROPS */, ["bestAnswerTitle"]))
              : _createCommentVNode("v-if", true),
            ($props.reply.isTenantReply)
              ? (_openBlock(), _createBlock($setup["ReplyTenantIcon"], { key: 1 }))
              : _createCommentVNode("v-if", true)
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ], 2 /* CLASS */))
}